import styles from '../styles/styles.module.css';

const themes = (darkMode: boolean) => {
  const darkModeBG = darkMode ? ` ${styles['customer-info-panel-dark']}` : '';
  const darkModeBorder = darkMode ? ` ${styles['customer-info-panel-dark-border']}` : '';
  const darkModea = darkMode ? ` ${styles['a-dark']}` : '';
  const darkModeTitle = darkMode ? ` ${styles['accordion-title-dark']}` : '';
  const darkModeaAdobeBold = darkMode ? ` ${styles['adobe-clean-bold-dark']}` : '';
  const darkModeaAdobeRegular = darkMode ? ` ${styles['adobe-clean-regular-dark']}` : '';
  const darkModeaAdobeRegularOr = darkMode ? ` ${styles['adobe-clean-regular-or-dark']}` : '';
  const darkModeWidgetHeader = darkMode ? ` ${styles['cip-widget-header-dark']}` : '';
  const darkModeNotFound = darkMode ? ` ${styles['scip-customer-not-found-dark']}` : '';
  const darkModeFieldValues = darkMode ? ` ${styles['accordion-content-fields-values-isnota-dark']}` : '';

  return {
    darkMode,
    darkModeBG,
    darkModeBorder,
    darkModea,
    darkModeTitle,
    darkModeaAdobeBold,
    darkModeaAdobeRegular,
    darkModeaAdobeRegularOr,
    darkModeWidgetHeader,
    darkModeNotFound,
    darkModeFieldValues
  };
};

export default themes; 